import React, { useCallback,useState, useEffect } from "react";
import styled from "styled-components";
import { injectIntl } from 'react-intl'
import { useDebounce } from 'use-lodash-debounce'

const Wrapper = styled.div`
  display:flex;
  flex-direction: column;
  justify-content:center;
  align-items:center;
  height:500px;
  border: 1px solid ${p => p.theme.colors.border};
  border-radius:25px;
  background:white;

`


const File = styled.div`
  display:flex;
  align-items:center;
  justify-content:center;
  font-size: 180px;
`

export default injectIntl((props) => {

  return (
    <Wrapper>
      <File className="fal fa-list-alt"/>
      <h1>{props.intl.formatMessage({id:"Summary"})}</h1>
    </Wrapper>
    
  );
});
